import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { getPerceptionOfCoverageData } from 'page_modules/business-pdp/redux';
import { Color, Box, Icon, Size } from '@americanexpress/aqx-components';

import styles from './__styles__/index.scss?modules';
import withPropTestingData from 'src/universal/components/WithPropTestingData';
import { DATA_TYPES } from 'src/universal/redux/propTesting';

const perceptionOfCoverage = React.memo(({ pocData }) => {
  return (
    <Box
      $border={true}
      className={clsx(styles.pocWrap, { [styles.hasData]: !!pocData })}
      theme={{ rounded: Size.SM }}
    >
      <Icon
        className={styles.iconHolder}
        directory="dls"
        imageName="dls-icon-global"
        hiddenToScreenReaders={true}
        theme={{
          color: Color.BrightBlue
        }}
      />
      <Sanitizer
        className={styles.textHolder}
        safelySetInnerHTML={pocData.description}
      />
    </Box>
  );
});

const mapStateToProps = state => ({
  pocData: getPerceptionOfCoverageData(state)
});

const PropsTestedPerceptionOfCoverage = withPropTestingData(
  perceptionOfCoverage,
  'PerceptionOfCoverage',
  DATA_TYPES.cardData
);
export const PerceptionOfCoverage = connect(mapStateToProps)(
  PropsTestedPerceptionOfCoverage
);
